import type { BufferGeometry } from 'three'
import type { Ponto2 } from '../componentes/contornos2d'
import { aneisDePega, extrusao, torno } from '../componentes/malhasProcedurais'
import type { NivelQualidade } from '../ambiente/qualidadeGrafica'
import { contornoCabeca, contornoFaixaGume, contornoLamina } from './geometriaCortador'

export const ESPESSURA_LAMINA = 0.019
/** Cada lâmina fica de um lado do plano médio: é o que deixa elas se cruzarem. */
export const DESVIO_LAMINA = 0.0105
export const ESPESSURA_PLACA_CABECA = 0.012

const DETALHE: Record<NivelQualidade, { passos: number; chanfro: number; torno: number }> = {
  alta: { passos: 14, chanfro: 3, torno: 40 },
  media: { passos: 10, chanfro: 2, torno: 28 },
  baixa: { passos: 6, chanfro: 1, torno: 16 },
}

/** Cilindro laranja com tampas chanfradas e sulco de vedação, e o colar preto à frente. */
const PERFIL_CILINDRO: Ponto2[] = [
  // começa dentro da carcaça do motor (que termina em -0,15): sem vão entre os dois
  [-0.16, 0],
  [-0.16, 0.05],
  [-0.15, 0.05],
  [-0.146, 0.054],
  [0.14, 0.054],
  [0.144, 0.05],
  [0.15, 0.05],
  [0.154, 0.054],
  [0.172, 0.054],
  [0.18, 0.046],
  [0.18, 0],
]

const PERFIL_COLAR: Ponto2[] = [
  [0.176, 0],
  [0.176, 0.05],
  [0.182, 0.052],
  [0.24, 0.048],
  [0.252, 0.038],
  [0.252, 0],
]

/** Manopla de comando traseira com anéis de pega e terminal abaulado. */
function perfilManopla(): Ponto2[] {
  return [
    [-0.468, 0],
    [-0.466, 0.012],
    [-0.46, 0.02],
    [-0.452, 0.024],
    ...aneisDePega(-0.45, -0.37, 0.024, 0.003, 5),
    [-0.366, 0.024],
    [-0.36, 0.028],
    [-0.33, 0.028],
    [-0.326, 0.022],
    [-0.31, 0.022],
    [-0.31, 0],
  ]
}

export interface MalhasCortador {
  readonly lamina: BufferGeometry
  readonly faixaGume: BufferGeometry
  readonly placaCabeca: BufferGeometry
  readonly cilindro: BufferGeometry
  readonly colar: BufferGeometry
  readonly manopla: BufferGeometry
}

const CACHE = new Map<NivelQualidade, MalhasCortador>()

/** Geometrias do cortador por nível, montadas uma vez e compartilhadas (ver `malhasAlargador`). */
export function malhasCortador(nivel: NivelQualidade): MalhasCortador {
  const existente = CACHE.get(nivel)
  if (existente) return existente

  const d = DETALHE[nivel]
  const malhas: MalhasCortador = {
    lamina: extrusao(contornoLamina(d.passos), ESPESSURA_LAMINA, 0.004, d.chanfro),
    // um fio de espessura a mais que a lâmina: aparece no chanfro das faces
    faixaGume: extrusao(contornoFaixaGume(d.passos), ESPESSURA_LAMINA + 0.0008, 0.001, 1),
    placaCabeca: extrusao(contornoCabeca(d.passos), ESPESSURA_PLACA_CABECA, 0.003, d.chanfro),
    cilindro: torno(PERFIL_CILINDRO, d.torno),
    colar: torno(PERFIL_COLAR, d.torno),
    manopla: torno(perfilManopla(), d.torno),
  }
  CACHE.set(nivel, malhas)
  return malhas
}
